import { render, staticRenderFns } from "./PriceIncrease2026.vue?vue&type=template&id=234b19ab&scoped=true"
import script from "./PriceIncrease2026.vue?vue&type=script&lang=js"
export * from "./PriceIncrease2026.vue?vue&type=script&lang=js"
import style0 from "./PriceIncrease2026.vue?vue&type=style&index=0&id=234b19ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234b19ab",
  null
  
)

export default component.exports